import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Download, X } from 'lucide-react';

export default function BackupReminder({ onOpenSettings }) {
  const { showBackupReminder, dismissBackupReminder, lastBackupAt } = useAuth();

  if (!showBackupReminder) return null;

  return (
    <div 
      className="fixed bottom-4 right-4 z-50 max-w-sm bg-card border border-border rounded-lg shadow-lg p-4 animate-slide-up"
      data-testid="backup-reminder"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-full bg-accent-amber/20 flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5 text-accent-amber" />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground">Backup Reminder</h4>
          <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
            {lastBackupAt 
              ? "It's been over a week since your last backup. Keep your notes safe!" 
              : "You haven't created a backup yet. Protect your notes with an encrypted backup."}
          </p>
          <div className="flex gap-2 mt-3">
            <Button 
              size="sm" 
              onClick={onOpenSettings}
              className="h-7 text-xs"
              data-testid="backup-reminder-action"
            >
              <Download className="w-3 h-3 mr-1" /> Backup Now
            </Button>
            <Button 
              size="sm" 
              variant="ghost"
              onClick={dismissBackupReminder}
              className="h-7 text-xs text-muted-foreground"
              data-testid="backup-reminder-dismiss"
            >
              Remind Later
            </Button>
          </div>
        </div>
        <button 
          onClick={dismissBackupReminder}
          className="text-muted-foreground hover:text-foreground p-1 -mr-1 -mt-1"
          data-testid="backup-reminder-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
